var m;

export class DiceObject {
	constructor(num, mgr){
		m = mgr;
		this.diceSprite = null;
		this.diceImage = null;
		this.diceContainer = null;

		this.diceNum = num;
		this.defaultHomePosition = {x:0, y:0};
		this.lastPosition = {x:0, y:0};
		this.homePosition = {x:0, y:0};
		this.frameNum = -1;
		this.currentFace = 0;
		this.locked = false;
		this.lockedSortOrder = 0;
		this.tinyDeltaX = 0;
		this.tinyDeltaY = 0;
		this.highlight = null;
		this.expl = null;
		//this.soundsPlayed = 0;
		this.highlightOffset = 4;
	}
	getFrameNumber = () => {
		const frame = this.diceImage?.frame
		const row = frame ? Math.trunc(frame.cutY/frame.cutHeight) : 0;
		const col = frame ? Math.trunc(frame.cutX/frame.cutWidth) : 0;
		return 6*row + col;
	}

	enableCollision = par => {
		this.diceSprite.body.moves = par;
		this.diceSprite.body.collisionFilter.group = par ? 0 : -1;
		this.diceSprite.body.collisionFilter.mask = par ? 1 : 0;
	}

	addFlair = (animType) => {
		this.removeFlair();
		this.highlight = m.scene.add.sprite(0,this.highlightOffset, 'flair')
			.setScale(m.highlightScale*1.01)
			//.setFrame(3);
		this.diceContainer.add(this.highlight);
		this.highlight.anims.play(animType, true);
	}	
	addExplosion = () => {
		this.expl = m.scene.add.sprite(this.diceImage.x, this.diceImage.y, 'dice_explosion')
			.setOrigin(0.5)
			.setScale(3*this.diceImage.scaleX)
			//.setFrame(1);
		this.diceContainer.add(this.expl);
		this.expl.anims.play('diceExplosion', true);
	}

	addSelectPulse = () => {
		this.removeFlair();
		this.highlight = m.scene.add.sprite(this.diceSprite.x, this.diceSprite.y+this.highlightOffset, 'flair');
		this.highlight.setScale(m.highlightScale * 1.06);
		this.highlight.setFrame(26);
		this.highlight.setAlpha(0.50);
		// this.highlight.anims.play(animType, true);
		var tween = m.scene.tweens.add({
			targets     : [ this.highlight ],
			scaleX: m.highlightScale * 1.5,
			scaleY: m.highlightScale * 1.5,
			//   ease        : 'Expo.easeIn',
			ease		  : 'Linear',
			duration    : 350,
			repeat      : -1,
			yoyo: true
		});
		m.scoreCardTweens.push(tween);
	}
	addSelectPulseYellowDot = () => {
		this.removeFlair();
		this.highlight = m.scene.add.sprite(this.diceSprite.x, this.diceSprite.y+this.highlightOffset, 'flairYellowDot');
		this.highlight.setScale(m.highlightScale * 1.06);
		this.highlight.setFrame(26);
		this.highlight.setAlpha(0.50);
		// this.highlight.anims.play(animType, true);
		var tween = m.scene.tweens.add({
			targets     : [ this.highlight ],
			scaleX: m.highlightScale * 1.5,
			scaleY: m.highlightScale * 1.5,
			//   ease        : 'Expo.easeIn',
			ease		  : 'Linear',
			duration    : 350,
			repeat      : -1,
			yoyo: true
		});
		m.scoreCardTweens.push(tween);
	}

	removeFlair = () => {
		if(this.highlight != null)
			this.highlight.destroy();
		this.highlight = null;
	}

	darken = () => {
		this.removeFlair();
		this.highlight = m.scene.add.sprite(this.diceSprite.x-1, this.diceSprite.y-1, 'flair');
		this.highlight.setScale(m.highlightScale*1.01);
		this.highlight.setAlpha(0.4);
	}
};
